import { Col, Row } from 'antd';
import { FormItem } from 'modules/common/components';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { contactFields } from './fields';

type Props = {
  fieldNamePrefix: string;
  enabled: boolean;
};

const AdditionalContactsField: FC<Props> = ({ fieldNamePrefix, enabled }) => {
  const { t } = useTranslation(
    'owner.EditOwnerProfileForm.AdditionalContactsSection'
  );
  const { control, formState, getFieldState } = useFormContext();

  return (
    <Col span={24}>
      <h2>{t('additionalContact')}</h2>
      {contactFields.map(({ name, label, Component }) => {
        const fieldName = `${fieldNamePrefix}.${name}`;
        const { error } = getFieldState(fieldName, formState);

        return (
          <Row key={fieldName}>
            <Col span={24}>
              <FormItem
                label={label}
                extra={error?.message}
                validateStatus={error ? 'error' : undefined}
              >
                <Component
                  name={fieldName}
                  control={control}
                  disabled={!enabled}
                />
              </FormItem>
            </Col>
          </Row>
        );
      })}
    </Col>
  );
};

export default AdditionalContactsField;
